<template>
  <div class="setting-group">
    <Divider v-if="divider" />
    <h3>
      {{
        $t(`settingsCategories.${normalizeI18nKey(group.label)}`, group.label)
      }}
    </h3>
    <div
      v-for="setting in group.settings"
      :key="setting.id"
      class="setting-item mb-4"
    >
      <SettingItem v-if="showSettingLabel(setting.id)" :setting="setting" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Divider from 'primevue/divider'
import { computed } from 'vue'
import SettingItem from '@/components/dialog/content/setting/SettingItem.vue'
import { SettingParams } from '@/types/settingTypes'
import { normalizeI18nKey } from '@/utils/formatUtil'

defineProps<{
  group: {
    label: string
    settings: SettingParams[]
  }
  divider?: boolean
}>()

const showSettingLabel = computed(() => {
  return (id: string) => {
    return [
      'Comfy.Locale', 
      'pysssss.SnapToGrid',
      'Comfy.SnapToGrid.GridSize', 
      'Comfy.LinkRenderMode', 
      'Comfy.Graph.LinkMarkers', 
    ].includes(id)
  }
})
</script>
